import { EMPTY_LIST } from '../../../constants/common'
import { FilterDivider } from '../../FilterDivider'
import { PageActions } from '../../Page'
import { Pagination } from '../../Pagination'
import { SelectionToolbar } from '../../SelectionToolbar'
import {
  getSelectedSize,
  getTableResetSortingButton,
  Table,
  TableConfigModal,
  TableControlBar,
  TableControlButtons,
  TableMassAction,
} from '../../Table'
import { ProviderTableRow } from '../ProviderTableRow'

import * as styles from './ProviderTableLayout.module.css'

function ProviderTableLayout({
  emptyState = null,
  extraModals = null,
  getProviderItemActions,
  hasTable,
  massActions = EMPTY_LIST,
  modal = null,
  setItemAction,
  setMassAction,
  tablePage,
}) {
  const {
    checkIsItemSelected,
    columns,
    entity,
    exclude,
    handleApply,
    handleClickRow,
    handleConfigOpen,
    handleExclude,
    handleMouseDownRow,
    handleResetOrdering,
    handleSelect,
    handleSelectAll,
    handleSelectAllPages,
    handleSetColumns,
    handleSetOrdering,
    handleSetPagination,
    handleSetSize,
    handleUnselectAllPages,
    isAllSelected,
    isConfigOpen,
    isLoading,
    isRemoveSelection,
    items,
    ordering,
    pageScrollWrapperRef,
    pagination,
    refreshButtonProps,
    requiredColumns,
    selectAllPages,
    selected,
    setConfigOpen,
  } = tablePage

  const hasMassActions = massActions.length > 0

  return (
    <>
      {hasTable ? (
        <>
          <TableControlBar>
            {hasMassActions ? (
              <TableMassAction
                responsive
                actions={massActions}
                isAllSelected={isAllSelected}
                isLoading={isLoading}
                isRemoveSelection={isRemoveSelection}
                selectedSize={getSelectedSize({
                  exclude,
                  pagination,
                  selectAllPages,
                  selected,
                })}
                setMassAction={setMassAction}
                onSelectAll={handleSelectAll}
              />
            ) : null}
            <PageActions className={styles.pageActions} isLoading={isLoading}>
              <TableControlButtons
                DensityButton={null}
                ResetSortingButton={getTableResetSortingButton(ordering)}
                configButtonProps={{ onClick: handleConfigOpen }}
                refreshButtonProps={refreshButtonProps}
                resetSortingProps={{ onClick: handleResetOrdering }}
              />
              <FilterDivider />
              <Pagination
                responsive
                value={pagination}
                onChange={handleSetPagination}
                onChangeSize={handleSetSize}
              />
            </PageActions>
          </TableControlBar>
          <Table
            TableRow={ProviderTableRow}
            actionsColumnWidth={hasMassActions ? undefined : 0}
            checkIsItemSelected={checkIsItemSelected}
            columns={columns}
            containerRef={pageScrollWrapperRef}
            headerRowProps={{
              ordering,
              onApply: handleApply,
              onSetColumns: handleSetColumns,
              onSetOrdering: handleSetOrdering,
            }}
            isLoading={isLoading}
            items={items?.items}
            rowProps={{
              Actions: hasMassActions ? undefined : null,
              exclude,
              getActions: getProviderItemActions,
              isSelectedAll: selectAllPages,
              selected,
              onCallAction: setItemAction,
              onClick: handleClickRow,
              onMouseDown: handleMouseDownRow,
              onSelect: selectAllPages ? handleExclude : handleSelect,
            }}
          />
        </>
      ) : (
        emptyState
      )}
      {selected.length > 0 || selectAllPages ? (
        <SelectionToolbar
          allSelected={selectAllPages || selected.length === pagination.count}
          count={pagination.count}
          excludeCount={exclude.length}
          selected={selected.length}
          onClose={handleUnselectAllPages}
          onSelectAll={handleSelectAllPages}
        />
      ) : null}
      {isConfigOpen ? (
        <TableConfigModal
          columns={columns}
          entity={entity}
          requiredColumns={requiredColumns}
          setColumns={handleSetColumns}
          setConfigOpen={setConfigOpen}
          onApply={handleApply}
        />
      ) : null}
      {modal}
      {extraModals}
    </>
  )
}

export default ProviderTableLayout
